import { collectPagedResource, get } from '../httpHelpers/reporter';
import { Report } from '../../types/Series';
import { BusinessUnit, Series } from '@cambridgeassessment/lib-ee-commons';

export const getSeriesReports = (businessUnitId: BusinessUnit['id'], reportType: string): Promise<Report[]> =>
  collectPagedResource(`v1/${businessUnitId}?reportType=${reportType}`);

export const getSeriesWithRMAErrors = (businessUnitId: BusinessUnit['id']): Promise<Report[]> =>
  get(`v1/${businessUnitId}/rma-errors-series`);

export const downloadReport = (
  businessUnitId: BusinessUnit['id'],
  series: { id: Series['id']; name: Series['name'] },
  reportType: string,
): Promise<Blob> =>
  get(
    `v1/${businessUnitId}/series/${series.id}/report/${reportType}/file?seriesName=${encodeURIComponent(series.name)}`,
  );

export const buildReport = (
  businessUnitId: BusinessUnit['id'],
  series: { id: Series['id']; name: Series['name'] },
  reportType: string,
): Promise<Blob> => get(`v1/${businessUnitId}/series/${series.id}/report/${reportType}/build`);

export const getUnsubmittedReportDownloadLink = async (
  businessUnitId: BusinessUnit['id'],
  seriesId: Series['id'],
  reportType: string,
): Promise<string | null> => get(`v1/${businessUnitId}/series/${seriesId}/report/${reportType}/download-link`);
